var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInterestedPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2957_663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1134 12.2123C12.1471 11.5363 12.8247 10.373 12.8247 9.05225C12.8247 6.96904 11.1359 5.28027 9.05273 5.28027C6.96953 5.28027 5.28076 6.96904 5.28076 9.05225C5.28076 10.373 5.9584 11.5363 6.99205 12.2123C7.63984 12.6359 8.21649 13.3796 8.29036 14.333H9.81511C9.88898 13.3796 10.4656 12.6359 11.1134 12.2123ZM11.9392 13.475C11.5736 13.7141 11.3159 14.1032 11.3159 14.54V14.7102C11.3159 15.3352 10.8093 15.8418 10.1843 15.8418H7.92114C7.29618 15.8418 6.78955 15.3352 6.78955 14.7102V14.54C6.78955 14.1032 6.53187 13.7141 6.16626 13.475C4.72454 12.5322 3.77197 10.9035 3.77197 9.05225C3.77197 6.13576 6.13625 3.77148 9.05273 3.77148C11.9692 3.77148 14.3335 6.13576 14.3335 9.05225C14.3335 10.9035 13.3809 12.5322 11.9392 13.475Z",
    fill: "#7C87FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.29834,
    width: 1.50879,
    height: 2.26318,
    rx: 0.754395,
    fill: "#7C87FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.3546,
    y: 1.68457,
    width: 1.50879,
    height: 2.26318,
    rx: 0.754395,
    transform: "rotate(45 15.3546 1.68457)",
    fill: "#7C87FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.3512,
    y: 3.28418,
    width: 1.50879,
    height: 2.26318,
    rx: 0.754395,
    transform: "rotate(135 4.3512 3.28418)",
    fill: "#7C87FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.26318,
    y: 8.29883,
    width: 1.50879,
    height: 2.26318,
    rx: 0.754395,
    transform: "rotate(90 2.26318 8.29883)",
    fill: "#7C87FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1055,
    y: 8.29883,
    width: 1.50879,
    height: 2.26318,
    rx: 0.754395,
    transform: "rotate(90 18.1055 8.29883)",
    fill: "#7C87FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.78955,
    y: 16.5967,
    width: 4.52637,
    height: 1.50879,
    rx: 0.754395,
    fill: "#7C87FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2957_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1055,
    height: 18.1055,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterestedPurple);
export default __webpack_public_path__ + "static/media/icon-interested-purple.389edb9b9f5ec926721d19ab82965171.svg";
export { ForwardRef as ReactComponent };